import BrdidNumbersPanel from '@/components/did/BrdidNumbersPanel'
import VoiceSectionPage from '@/components/layout/VoiceSectionPage'

export default function NumerosPage() {
  return (
    <VoiceSectionPage
      title="Comprar números avulsos"
      description="Contrate números de telefone avulsos para sua conta diretamente na plataforma."
    >
      <BrdidNumbersPanel />
    </VoiceSectionPage>
  )
}
